module.exports = __webpack_public_path__ + "static/media/kudu2.00c2c80c.jpg";